import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Philosphy = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.111.7H9.18a5.153 5.153 0 0 0-5.188 5.188v27.937C1.796 34.224 0 36.12 0 38.515c0 2.693 2.095 4.788 4.79 4.788h30.73c2.494 0 4.49-1.895 4.788-4.29V10.08A4.822 4.822 0 0 0 44 5.389 4.858 4.858 0 0 0 39.111.7ZM31.43 41.01H4.789a2.47 2.47 0 0 1-2.494-2.495c0-1.397 1.097-2.594 2.494-2.594h26.64c-.5.699-.699 1.596-.699 2.494 0 .998.2 1.796.699 2.595Zm3.99 0a2.47 2.47 0 0 1-2.494-2.495 2.47 2.47 0 0 1 2.495-2.494 2.47 2.47 0 0 1 2.494 2.494c.1 1.397-.998 2.495-2.495 2.495Zm2.595-6.585c-.699-.5-1.597-.699-2.495-.699H6.186V5.888c0-1.596 1.297-2.993 2.993-2.993h28.835v31.529Zm2.195-26.74v-4.49c.798.4 1.396 1.298 1.396 2.295 0 .998-.498 1.796-1.396 2.195Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.172 11.276c0-.598.5-1.097 1.098-1.097h17.66c.598 0 1.097.498 1.097 1.097s-.499 1.098-1.097 1.098H13.27a1.107 1.107 0 0 1-1.098-1.098ZM12.172 19.258c0-.599.5-1.098 1.098-1.098h17.66c.598 0 1.097.5 1.097 1.098 0 .599-.499 1.098-1.097 1.098H13.27c-.599.1-1.098-.4-1.098-1.098ZM12.172 27.34c0-.599.5-1.098 1.098-1.098h8.88c.598 0 1.097.499 1.097 1.098 0 .598-.499 1.097-1.097 1.097h-8.88c-.599.1-1.098-.499-1.098-1.097Z"
  }));
});
Philosphy.displayName = 'Philosphy';
Philosphy.defaultProps = {
  'aria-label': 'Philosphy'
};
export default Philosphy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Philosphy.js
// module id = 3063
// module chunks = 11